import dorisRequest from "../untils/dorisRequest";

// 通用-客户上传还款凭证
export const currentUploadFile = (query) => {
  return dorisRequest({
    url: "/doris/weChat/client/uploadFile",
    method: "post",
    data: query,
  });
};
// 通用-公众号联系调解员
export const currentConnectMediator = (query) => {
  return dorisRequest({
    url: "/doris/weChat/connect/mediator",
    method: "post",
    data: query,
  });
};
// 通用-法院公众号案件详情
export const currentLoanDetail = (query) => {
  return dorisRequest({
    url: "/doris/weChat/loan/detail",
    method: "post",
    data: query,
  });
};
// 通用-法院公众号发送验证码
export const currentSendSmsCode = (query) => {
  return dorisRequest({
    url: "/doris/weChat/smsCode/send",
    method: "post",
    data: query,
  });
};
// 通用-法院公众号用户登录
export const currentLogin = (query) => {
  return dorisRequest({
    url: "/doris/weChat/user/login",
    method: "post",
    data: query,
  });
};
// 通用-公众号二维码扫描
export const currentScanRecord = (query) => {
  return dorisRequest({
    url: "/doris/weChat/qrCode/scan",
    method: "post",
    data: query,
  });
};
